import { BlogPost } from './BlogPost.js'

const arrow = /*html*/ `
  <svg class="c-icon-arrow-right" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.52624 3.35889L13.2501 7.08275C13.7708 7.60344 13.7708 8.44766 13.2501 8.96836L9.52624 12.6922M13.3626 8.02555H2.35958" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  `
export function BlogPostCarousel({ slides = [], title, url, globals }) {
  const noSlides = slides.length === 0

  return /*html*/ `
  <div class="c-filtered-list-items splide" data-animate-section>
    <div class="c-filtered-list-items-header">
      <h2 class="c-filtered-list-title-text ts-2" data-animate-title>${title}</h2>
      <a href="${url}" class="c-button c-button--ts-2 c-button--blue-light" data-animate data-animate-x="50" data-animate-delay="100">
        <span class="c-button-bg">
          <span class="c-button-bg-hover"></span>
        </span>
        <span class="c-button-text">
          <span class="c-button-text-inner">
            <span class="c-button-text-hover">${globals.labelViewAll ?? 'View all'}</span>
            <span class="c-button-text-static">${globals.labelViewAll ?? 'View all'}</span>
          </span>
        </span>
      </a>
      <div class="c-carousel-controls splide__arrows" data-animate data-animate-x="50" data-animate-delay="130">
        <button class="c-carousel-control-prev splide__arrow splide__arrow--prev" aria-label="Previous">${arrow}</button>
        <button class="c-carousel-control-next splide__arrow splide__arrow--next" aria-label="Next">${arrow}</button>
      </div>
    </div>
    ${noSlides ? /*html*/ `<div class="c-filtered-list-items-no-results">${globals.labelNoResults ?? 'No results found'}</div>` : ``}
    <div class="splide__track">
      <ul class="c-filtered-list-items-ul splide__list">
        ${slides
          .map(
            (slide) => /*html*/ `
              <li class="c-filtered-list-item-li splide__slide">
                ${BlogPost({
                  ...slide,
                  buttonText: globals.labelReadMore,
                  eventDatePrefix: globals.labelPrefixEventDate,
                })}
              </li>
            `
          )
          .join('')}
      </ul>
    </div>
  </div>
  `
}
